
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"124","height":"124","fill":"#3D2562","rx":"16"}}),_c('path',{attrs:{"fill":"#7E5FDD","d":"M62 37.001l-21 10 1 16 20 23 15-9c2.667-6 4-9.333 4-10 0-.666.333-3.333 1-8 .667-4 .667-6.333 0-7-.667-.666-7.333-5.666-20-15z"}}),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M59.93 34.443l-17.889 7.984A5.156 5.156 0 0039 47.125v12.067C39 73.441 48.813 86.765 62 90c13.187-3.235 23-16.56 23-30.808V47.125a5.156 5.156 0 00-3.041-4.698L64.07 34.443a5.06 5.06 0 00-4.14 0zM62 61.733h17.889c-1.355 10.578-8.382 20-17.889 22.953V61.759H44.111V47.125L62 39.141v22.593z"}})])])
          )
        }
      }
    